import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Icon from '@mui/material/Icon';

import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import DataTable from 'examples/Tables/DataTable';
import { useLoading } from 'context/loading.context';
import { useMaterialUIController } from 'context';
import { getCountries, getCarriers, getCorporateClients, getWhatsappTemplates, getPaymentModes, getReceivingAccounts, getDeclarations, getTrackingMessages } from 'network/service';

import AddCountry from './components/addCountry';
import AddCarrier from './components/addCarrier';
import AddEditCorporate from './components/addEditCorporate';
import AddPaymentMode from './components/addPaymentMode';
import AddReceivingAccount from './components/addReceivingAccount';
import AddDeclaration from './components/addDeclaration';
import AddTrackingMessage from './components/addTrackingMessage';

import BranchTable from './data';
import AddTemplate from './components/addTemplate';
export default function Configurations() {

    const { showLoader, hideLoader } = useLoading();
    const [controller, dispatch] = useMaterialUIController();
    const [carrierPopup, setCarrierPopup] = useState({ open: false, details: null });
    const [countryPopup, setCountryPopup] = useState({ open: false, details: null });
    const [templatePopup, setTemplatePopup] = useState({ open: false, details: null });
    const [corporatePopup, setCorporatePopup] = useState({ open: false, details: null });
    const [paymentModePopup, setPaymentModePopup] = useState({ open: false, details: null });
    const [receivingAccountPopup, setReceivingAccountPopup] = useState({ open: false, details: null });
    const [declarationPopup, setDeclarationPopup] = useState({ open: false, details: null });
    const [trackingMessagePopup, setTrackingMessagePopup] = useState({ open: false, details: null });
    const { sidenavColor } = controller;
    const [countries, setCountries] = useState([]);
    const [clients, setClients] = useState([]);
    const [carriers, setCarriers] = useState([]);
    const [paymentModes, setPaymentModes] = useState([]);
    const [receivingAccounts, setReceivingAccounts] = useState([]);
    const [declarations, setDeclarations] = useState([]);
    const [trackingMessages, setTrackingMessages] = useState([]);
    const [tmps, setTmps] = useState([]);


    const { formCountryRows, carrierHeaders, formCarrierRows,
        countryHeaders, formCorporateRows, corporateHeaders,
        templateHeaders, formTemplateRows, paymentModeHeaders, formPaymentModeRows,
        receivingAccountHeaders, formReceivingAccountRows, declarationHeaders, formDeclarationRows,
        trackingMessageHeaders, formTrackingMessageRows
    } = BranchTable();


    const fetchCountries = () => {
        showLoader();
        getCountries()
            .then((resp) => {
                hideLoader();
                setCountries(resp.data);
            })
            .catch((err) => {
                hideLoader();
                console.log(err);
            });
    };

    const fetchCarriers = () => {
        getCarriers().then((resp) => {
            setCarriers(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchCorporateClients = () => {
        getCorporateClients().then((resp) => {
            setClients(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchTemplatesAll = () => {
        getWhatsappTemplates().then((resp) => {
            setTmps(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchPaymentModes = () => {
        getPaymentModes().then((resp) => {
            setPaymentModes(resp.data || []);
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchReceivingAccounts = () => {
        getReceivingAccounts().then((resp) => {
            setReceivingAccounts(resp.data || []);
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchDeclarations = () => {
        getDeclarations().then((resp) => {
            setDeclarations(resp.data || []);
        }).catch((err) => {
            console.log(err);
        });
    }

    const fetchTrackingMessages = () => {
        getTrackingMessages().then((resp) => {
            setTrackingMessages(resp.data || []);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        fetchCountries();
    }, [setCountries]);

    useEffect(() => {
        fetchCarriers();
    }, [setCarriers]);

    useEffect(() => {
        fetchCorporateClients();
    }, [setClients]);

    useEffect(() => {
        fetchTemplatesAll();
    }, [setClients]);

    useEffect(() => {
        fetchPaymentModes();
    }, [setPaymentModes]);

    useEffect(() => {
        fetchReceivingAccounts();
    }, [setReceivingAccounts]);

    useEffect(() => {
        fetchDeclarations();
    }, [setDeclarations]);

    useEffect(() => {
        fetchTrackingMessages();
    }, [setTrackingMessages]);

    const exportToExcel = (data, filename) => {
        try {
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            XLSX.writeFile(wb, `${filename}.xlsx`);
        } catch (error) {
            console.error('Error exporting to Excel:', error);
        }
    };

    const editTemp = (details) => {
        setTemplatePopup({ open: true, details: details });
    }



    return (


        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                {carrierPopup.open && <AddCarrier isopen={carrierPopup.open} details={carrierPopup.details} handleclose={() => { setCarrierPopup({ open: false, details: null }) }} handlesuccess={() => { fetchCarriers(); setCarrierPopup({ open: false, details: null }) }} />}
                {countryPopup.open && <AddCountry isopen={countryPopup.open} details={countryPopup.details} handleclose={() => { setCountryPopup({ open: false, details: null }) }} handlesuccess={() => { fetchCountries(); setCountryPopup({ open: false, details: null }) }} />}
                {corporatePopup.open && <AddEditCorporate isopen={corporatePopup.open} details={corporatePopup.details} handleclose={() => { setCorporatePopup({ open: false, details: null }) }} handlesuccess={() => { fetchCorporateClients(); setCorporatePopup({ open: false, details: null }) }} />}
                {templatePopup.open && <AddTemplate isopen={templatePopup.open} details={templatePopup.details} handleclose={() => { setTemplatePopup({ open: false, details: null }) }} handlesuccess={() => { fetchTemplatesAll(); setTemplatePopup({ open: false, details: null }) }} />}
                {paymentModePopup.open && <AddPaymentMode isopen={paymentModePopup.open} details={paymentModePopup.details} handleclose={() => { setPaymentModePopup({ open: false, details: null }) }} handlesuccess={() => { fetchPaymentModes(); setPaymentModePopup({ open: false, details: null }) }} />}
                {receivingAccountPopup.open && <AddReceivingAccount isopen={receivingAccountPopup.open} details={receivingAccountPopup.details} handleclose={() => { setReceivingAccountPopup({ open: false, details: null }) }} handlesuccess={() => { fetchReceivingAccounts(); setReceivingAccountPopup({ open: false, details: null }) }} />}
                {declarationPopup.open && <AddDeclaration isopen={declarationPopup.open} details={declarationPopup.details} handleclose={() => { setDeclarationPopup({ open: false, details: null }) }} handlesuccess={() => { fetchDeclarations(); setDeclarationPopup({ open: false, details: null }) }} />}
                {trackingMessagePopup.open && <AddTrackingMessage isopen={trackingMessagePopup.open} details={trackingMessagePopup.details} handleclose={() => { setTrackingMessagePopup({ open: false, details: null }) }} handlesuccess={() => { fetchTrackingMessages(); setTrackingMessagePopup({ open: false, details: null }) }} />}

                <Grid container spacing={6}>
                    <Grid item xl={6} md={12} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xl={12} md={12} xs={12} >
                                <Card sx={{ height: "100%" }}>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={3}
                                        px={2}
                                        variant="gradient"
                                        bgColor={sidenavColor}
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Carriers
                                        </MDTypography>
                                    </MDBox>
                                    <Stack
                                        direction="row-reverse"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                    >
                                        <MDBox pt={3} pr={3}>
                                            <MDButton
                                                variant="outlined"
                                                color="success"
                                                onClick={() => {
                                                    // setBranchPopup({ open: true, details: null });
                                                    setCarrierPopup({ open: true, details: null });
                                                }}
                                            >
                                                Add Carrier
                                            </MDButton>
                                        </MDBox>
                                    </Stack>
                                    <MDBox sx={{ maxHeight: "100vh", overflow: 'auto' }}>
                                        <DataTable
                                            entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                            table={{
                                                columns: carrierHeaders,
                                                rows: formCarrierRows(carriers)
                                            }}
                                            noEndBorder
                                            canSearch
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                            <Grid item xl={12} md={12} xs={12} mt={5}>
                                <Card sx={{ height: "100%" }}>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={3}
                                        px={2}
                                        variant="gradient"
                                        bgColor={sidenavColor}
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Corporate Clients
                                        </MDTypography>
                                    </MDBox>
                                    <Stack
                                        direction="row-reverse"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                    >
                                        <MDBox pt={3} pr={3}>
                                            <MDButton
                                                variant="outlined"
                                                color="success"
                                                onClick={() => {
                                                    setCorporatePopup({ open: true, details: null });
                                                }}
                                            >
                                                Add Clients
                                            </MDButton>
                                        </MDBox>
                                    </Stack>
                                    <MDBox sx={{ maxHeight: "100vh", overflow: 'auto' }}>
                                        <DataTable
                                            entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                            table={{
                                                columns: corporateHeaders,
                                                rows: formCorporateRows(clients)
                                            }}
                                            noEndBorder
                                            canSearch
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                            <Grid item xl={12} md={12} xs={12} mt={5}>
                                <Card sx={{ height: "100%" }}>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={3}
                                        px={2}
                                        variant="gradient"
                                        bgColor={sidenavColor}
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Payment Modes
                                        </MDTypography>
                                    </MDBox>
                                    <Stack
                                        direction="row-reverse"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                    >
                                        <MDBox pt={3} pr={3}>
                                            <MDButton
                                                variant="outlined"
                                                color="success"
                                                onClick={() => {
                                                    setPaymentModePopup({ open: true, details: null });
                                                }}
                                            >
                                                Add Payment Mode
                                            </MDButton>
                                        </MDBox>
                                    </Stack>
                                    <MDBox sx={{ maxHeight: "100vh", overflow: 'auto' }}>
                                        <DataTable
                                            entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                            table={{
                                                columns: paymentModeHeaders,
                                                rows: formPaymentModeRows(paymentModes, (details) => setPaymentModePopup({ open: true, details }))
                                            }}
                                            noEndBorder
                                            canSearch
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                            <Grid item xl={12} md={12} xs={12} mt={5}>
                                <Card sx={{ height: "100%" }}>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={3}
                                        px={2}
                                        variant="gradient"
                                        bgColor={sidenavColor}
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Receiving Accounts
                                        </MDTypography>
                                    </MDBox>
                                    <Stack
                                        direction="row-reverse"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                    >
                                        <MDBox pt={3} pr={3}>
                                            <MDButton
                                                variant="outlined"
                                                color="success"
                                                onClick={() => {
                                                    setReceivingAccountPopup({ open: true, details: null });
                                                }}
                                            >
                                                Add Receiving Account
                                            </MDButton>
                                        </MDBox>
                                    </Stack>
                                    <MDBox sx={{ maxHeight: "100vh", overflow: 'auto' }}>
                                        <DataTable
                                            entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                            table={{
                                                columns: receivingAccountHeaders,
                                                rows: formReceivingAccountRows(receivingAccounts, (details) => setReceivingAccountPopup({ open: true, details }))
                                            }}
                                            noEndBorder
                                            canSearch
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xl={12} md={12} xs={12} >
                                <Card sx={{ height: "100%" }}>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={3}
                                        px={2}
                                        variant="gradient"
                                        bgColor={sidenavColor}
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Countries
                                        </MDTypography>
                                    </MDBox>
                                    <Stack
                                        direction="row-reverse"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                    >
                                        <MDBox pt={3} pr={3}>
                                            <MDButton
                                                variant="outlined"
                                                color="success"
                                                onClick={() => {
                                                    setCountryPopup({ open: true, details: null });
                                                }}
                                            >
                                                Add Country
                                            </MDButton>
                                        </MDBox>
                                    </Stack>
                                    <MDBox sx={{ overflow: 'auto' }}>
                                        <DataTable
                                            entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                            table={{
                                                columns: countryHeaders,
                                                rows: formCountryRows(countries)
                                            }}
                                            noEndBorder
                                            canSearch
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                            <Grid item xl={12} md={12} xs={12} mt={5}>
                                <Card sx={{ height: "100%" }}>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={3}
                                        px={2}
                                        variant="gradient"
                                        bgColor={sidenavColor}
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Whatsapp Templates
                                        </MDTypography>
                                    </MDBox>
                                    <Stack
                                        direction="row-reverse"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                    >
                                        <MDBox pt={3} pr={3}>
                                            <MDButton
                                                variant="outlined"
                                                color="success"
                                                onClick={() => {
                                                    setTemplatePopup({ open: true, details: null });
                                                }}
                                            >
                                                Add Template
                                            </MDButton>
                                        </MDBox>
                                    </Stack>
                                    <MDBox sx={{ overflow: 'auto' }}>
                                        <DataTable
                                            entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                            table={{
                                                columns: templateHeaders,
                                                rows: formTemplateRows(tmps, editTemp)
                                            }}
                                            noEndBorder
                                            canSearch
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                            <Grid item xl={12} md={12} xs={12} mt={5}>
                                <Card sx={{ height: "100%" }}>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={3}
                                        px={2}
                                        variant="gradient"
                                        bgColor={sidenavColor}
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Declarations
                                        </MDTypography>
                                    </MDBox>
                                    <Stack
                                        direction="row-reverse"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                    >
                                        <MDBox pt={3} pr={3}>
                                            <MDButton
                                                variant="outlined"
                                                color="success"
                                                onClick={() => {
                                                    setDeclarationPopup({ open: true, details: null });
                                                }}
                                            >
                                                Add Declaration
                                            </MDButton>
                                        </MDBox>
                                    </Stack>
                                    <MDBox sx={{ overflow: 'auto' }}>
                                        <DataTable
                                            entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                            table={{
                                                columns: declarationHeaders,
                                                rows: formDeclarationRows(declarations, (details) => setDeclarationPopup({ open: true, details }))
                                            }}
                                            noEndBorder
                                            canSearch
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                            <Grid item xl={12} md={12} xs={12} mt={5}>
                                <Card sx={{ height: "100%" }}>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={3}
                                        px={2}
                                        variant="gradient"
                                        bgColor={sidenavColor}
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Tracking Messages
                                        </MDTypography>
                                    </MDBox>
                                    <Stack
                                        direction="row-reverse"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                    >
                                        <MDBox pt={3} pr={3}>
                                            <MDButton
                                                variant="outlined"
                                                color="success"
                                                onClick={() => {
                                                    setTrackingMessagePopup({ open: true, details: null });
                                                }}
                                            >
                                                Add Tracking Message
                                            </MDButton>
                                        </MDBox>
                                    </Stack>
                                    <MDBox sx={{ overflow: 'auto' }}>
                                        <DataTable
                                            entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                            table={{
                                                columns: trackingMessageHeaders,
                                                rows: formTrackingMessageRows(trackingMessages, (details) => setTrackingMessagePopup({ open: true, details }))
                                            }}
                                            noEndBorder
                                            canSearch
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}
